import React from 'react';
import { Badge } from '@shopify/polaris';
import { useLocation } from '../contexts/LocationContext';

interface LocationBadgeProps {
  showLabel?: boolean;
}

const LocationBadge: React.FC<LocationBadgeProps> = ({ showLabel = true }) => {
  const { locationLabel } = useLocation();

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
      {showLabel && <span style={{ fontSize: '13px', color: '#6D7175' }}>Location:</span>}
      <Badge tone="info">{locationLabel}</Badge>
    </div>
  );
};

export default LocationBadge;
